import { render, staticRenderFns } from "./pakistan_class_live.vue?vue&type=template&id=32f52732&scoped=true"
import script from "./pakistan_class_live.vue?vue&type=script&lang=js"
export * from "./pakistan_class_live.vue?vue&type=script&lang=js"
import style0 from "./pakistan_class_live.vue?vue&type=style&index=0&id=32f52732&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f52732",
  null
  
)

export default component.exports